import { ReactNode } from 'react';
import styled from 'styled-components';

import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled.div`
  display: grid;
  gap: var(--triple-unit);
  padding: var(--triple-unit);
  grid-template-areas:
    'yourCards'
    'topPlayers';
  grid-template-columns: 1fr;

  @media ${laptopAndAbove} {
    grid-template-areas:
      'yourCards separator topPlayers'
      'myLineups separator topPlayers';
    grid-template-columns: 1fr auto 1fr;
  }
`;

const Separator = styled.div`
  width: 1px;
  grid-area: separator;
  background-color: var(--c-nd-150);
`;

export const PlayersPageLayout = ({
  yourCards,
  topPlayers,
}: {
  yourCards: ReactNode;
  topPlayers: ReactNode;
}) => {
  const isLaptopAndAbove = useIsLaptop();

  return (
    <Root>
      <div style={{ gridArea: 'yourCards' }}>{yourCards}</div>
      {!!isLaptopAndAbove && <Separator />}
      <div style={{ gridArea: 'topPlayers' }}>{topPlayers}</div>
    </Root>
  );
};
